// File: frontend/src/components/WebOnlyPages.js
//
// Route wrappers for the marketing pages, which only exist on the website.
//
// Webpack inlines process.env.REACT_APP_IS_NATIVE at parse time. Putting the
// literal reference directly inside each `if` lets webpack fold the condition
// to a constant before building the dependency graph, so the require() (and
// the page's whole subtree — the release feed, the setup guide) is removed
// from native bundles. An intermediate `const`, a shared helper, or a loader
// closure would all defeat this — keep every process.env read inline and
// every require() in its own function.

import { Navigate } from 'react-router-dom';

export function HomePageWrapper() {
  if (process.env.REACT_APP_IS_NATIVE !== 'true') {
    const HomePage = require('./HomePage').default;
    return <HomePage />;
  }
  return <Navigate to="/login" replace />;
}

export function DownloadPageWrapper() {
  if (process.env.REACT_APP_IS_NATIVE !== 'true') {
    const DownloadPage = require('./DownloadPage').default;
    return <DownloadPage />;
  }
  return <Navigate to="/login" replace />;
}

export function InstallPageWrapper() {
  if (process.env.REACT_APP_IS_NATIVE !== 'true') {
    const InstallPage = require('./InstallPage').default;
    return <InstallPage />;
  }
  return <Navigate to="/login" replace />;
}
